import { useCallback } from 'react';
import { cookies } from '@/lib/jucyCookies';
import { addDays } from 'date-fns';
import { useRouter } from 'next/router';

export const useLocale = () => {
    const router = useRouter();
    const currentLocale = router.locale;

    const setLocale = useCallback(
        (locale: string) => {
            cookies.set('NEXT_LOCALE', locale, { expires: addDays(new Date(), 30) });
            if (currentLocale === locale) {
                return Promise.resolve();
            }
            return router.push('/', '/', { locale });
        },
        [router, currentLocale]
    );

    return [currentLocale, setLocale] as const;
};
